"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUploadCatalog = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const create_upload_mutation_1 = require("./create-upload.mutation");
const use_upload_file_hook_1 = require("./hooks/use-upload-file.hook");
const client_utils_1 = require("../client.utils");
const useUploadCatalog = () => {
    const { uploadFile } = (0, use_upload_file_hook_1.useUploadFile)();
    const [uploadCatalogMutation, _a] = (0, react_2.useMutation)(create_upload_mutation_1.CREATE_UPLOAD), { error: createUploadError } = _a, restOptions = __rest(_a, ["error"]);
    const uploadCatalog = (0, react_1.useCallback)((options) => __awaiter(void 0, void 0, void 0, function* () {
        const { variables: { name, file } = {} } = options, mutationOptions = __rest(options, ["variables"]);
        const uploadCatalogResponse = yield uploadCatalogMutation(Object.assign({ variables: { name } }, mutationOptions));
        (0, client_utils_1.genericGraphQLErrorsHandler)(uploadCatalogResponse);
        const { write: url } = uploadCatalogResponse.data.upload.urls;
        yield uploadFile(url, file);
        return uploadCatalogResponse;
    }), [uploadFile, uploadCatalogMutation]);
    return Object.assign({ uploadCatalog }, restOptions);
};
exports.useUploadCatalog = useUploadCatalog;
